import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=b01bd722&"
import script from "./LogoUpload.vue?vue&type=script&lang=js&"
export * from "./LogoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports